export default class ManagePhraseBookPhraseService {
  constructor () {
    'ngInject'
  }
}
